import React from "react";

import "./textarea.css";

const TextArea = ({ value, disabled, label, placeholder, onChange }) => {
  return (
    <div className="textAreaBorderd">
      <label className="mb-3 ddetail-input-label">{label}</label>
      <textarea
        className="textarea"
        disabled={disabled}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default TextArea;
